import { Box } from "@mui/material";
import { MerchantsTable } from "Components/Hunter/Merchants/MerchantsList/MerchantsTable";
import type { PartyLicenseDto } from "Infrastructure/Api/Api";

type Props = {
  licenses: Array<PartyLicenseDto>;
  ownOnly: boolean;
};

export const LicensesWithMerchants = ({ licenses, ownOnly }: Props) => (
  <Box display="grid" alignItems="start" rowGap={5}>
    {licenses.map((license) => (
      <MerchantsTable
        key={license.publicID}
        licensePublicID={license.publicID}
        ownOnly={ownOnly}
        license={license}
      />
    ))}
  </Box>
);
